module.exports = __webpack_public_path__ + "img/call.6a189608.svg";